import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
var SIGNUP_SOURCE;

(function (SIGNUP_SOURCE) {
  SIGNUP_SOURCE["CREATE_ACCOUNT"] = "createacct";
  SIGNUP_SOURCE["CHECKOUT"] = "togo_trans";
})(SIGNUP_SOURCE || (SIGNUP_SOURCE = {}));

var Config = /*#__PURE__*/function () {
  function Config() {
    _classCallCheck(this, Config);

    _defineProperty(this, "postfix", {
      UPDATE_ITEM: "/web-api/order/update",
      ADD_ITEM: "/web-api/order/add",
      DELETE_ITEM: "/web-api/order/delete",
      MOVE_TO_PURCHASE: "/web-api/order/moveToPurchase",
      LOCATION_TIME: "/web-api/order/pickup/location-time",
      SUBMIT_ORDER: "/web-api/order/submit",
      RESTAURANT_DETAILS: "/web-api/restaurant/{restaurantId}",
      SEARCH_RESTAURANT: "/web-api/restaurants",
      SESSION_DETAILS: "/web-api/session/details",
      CART_ORDER_DETAILS: "/web-api/order/detailed",
      CORS_URL: "/mAccountsWeb/AccountService/v1/tokens",
      CORS_URL_RSA: "/ucom/v1/account-tokens",
      RESOURCE_BUNDLE: "/web-api/i18n/resources",
      APP_INIT: "/web-api/appinit",
      SESSION_INIT: "/web-api/checkout/sessioninit",
      GC_SESSION_INIT: "/web-api/giftcardcheckout/sessioninit",
      GC_SUBMIT_ORDER: "/web-api/giftcardorder/submit",
      SESSION_TOKEN: "/web-api/paymentservice/sessiontoken",
      MOBILE_PAY_SESSION_TOKEN: "/web-api/paymentservice/mobilepay/sessiontoken",
      GC_SESSION_TOKEN: "/web-api/paymentservice/giftcard/sessiontoken",
      RSA_TOKEN: "/web-api/paymentservice/rsatoken",
      MOBILE_PAY_RSA_TOKEN: "/web-api/paymentservice/mobilepay/rsatoken",
      PROFILE_RSA_TOKEN: "/web-api/paymentservice/appRSAToken",
      GIFTCARD_RSA_TOKEN: "/web-api/paymentservice/giftcard/rsatoken",
      VALIDATE_TOKEN: "/web-api/paymentservice/validatetoken",
      MOBILE_PAY_VALIDATE_TOKEN: "/web-api/paymentservice/mobilepay/validatetoken",
      GIFT_CARD_VALIDATE_TOKEN: "/web-api/paymentservice/appValidateToken",
      APPLE_PAY_SESSION_TOKEN: "/web-api/paymentservice/apple/sessiontoken",
      APPLY_COUPON: "/web-api/order/applycoupon",
      REMOVE_COUPON: "/web-api/order/removecoupon",
      CHECK_GC_BALANCE: "/web-api/giftCard/checkBalance",
      LOGIN: "/web-api/profile/login",
      LOGOUT: "/web-api/profile/logout",
      SOCIAL_LINK: "/web-api/profile/sociallink",
      PROFILE: "/web-api/user/profile",
      TOKENIZE_PAYPAL: "/web-api/paymentservice/getPaypalAuthToken",
      PICKUP_TIMES: "/web-api/order/pickup/times",
      SETPICKUP_TIME: "/web-api/ordersettings/setpickuptime",
      CHECK_CARSIDE_AVAIL: "/web-api/order/carsidepickup/check-avail",
      CAPACITY_TIMES_SLOTS: "/web-api/order/pickup/capacitytimeslots",
      ZIPCODE_QUERY: "/commerce/payment/service/DardenPaymentServlet/getCityState",
      SAVE_GIFT_CARD: "/web-api/giftCard/addGiftCardToProfile",
      TOKENIZATION_FAILURE: "/commerce/payment/service/DardenPaymentServlet/xpayError",
      MOBILE_PAY_CHECK_API: "/web-api/mobilepay/orders",
      MOBILE_PAY_APPLY_COUPON_API: "/web-api/mobilepay/applycoupon",
      MOBILE_PAY_REMOVE_COUPON_API: "/web-api/mobilepay/removecoupon",
      MOBILE_PAY_PAYMENT_API: "/web-api/mobilepay/payments/",
      MOBILE_PAY_SEND_EMAIL_CONFIRMATION: "/web-api/receipts/orders/",
      MOBILE_PAY_SESSION_INIT: "/web-api/mobilepay/sessioninit",
      CATEGORY_MENU_ITEMS: "/web-api/menu?restaurantId={restaurantId}",
      MENU_ITEM_DETAILS: "/web-api/menuitem/{menuItemId}",
      MENU_ITEMS_86ED: "/web-api/restaurant/86edProducts?restaurantId={restaurantId}",
      ITEM_86ED: "/web-api/restaurant/{restaurantId}/86editems",
      MENU_DAY_PART_API: "/web-api/restaurant/getProductsDayPartInfo?restaurantId={restaurantId}",
      ORDER_HISTORY_API: "/web-api/profile/orders?startIndex={startIndex}&numOrders={numOrders}&expiryDays={expiryDays}",
      RECENT_ORDERS_API: "/web-api/to-come",
      LIST_FAVORITES_API: "/web-api/profile/favorite/products",
      SAVE_FAVORITES: "/web-api/favorite/add-favorite",
      REMOVE_FAVORITES: "/web-api/favorite/remove-favorite",
      CURBSIDE_CHECK_SUMMARY_API: "/api/curbside/checksummary",
      CURBSIDE_CHECK_SUMMARY_APIv2: "/api/curbside/v2/checksummary",
      CURBSIDE_CHECK_IN_API: "/api/curbside/checkin",
      CURBSIDE_RESTAURANT_NUMBER_API: "/web-api/restaurant/{restaurantNumber}?restNumFlag={restNumFlag}",
      UPDATE_LOCATION: "/web-api/restaurant/update",
      I18N_RESOURCES: "/web-api/i18n/resources",
      RECOMMENDATION_LIST_API: "/web-api/menu/recommendations",
      FREQUENTLY_ORDERED_ITEM: "/web-api/profile/frequentlyordered",
      CLEAR_CART: "/web-api/order/clearAndInitOrder",
      RESTAURANT_PDF_CONF: "/web-api/menu/pdf",
      SET_DELIVERY_PARTY_SIZE: "/web-api/ordersettings/setPartySize",
      GET_DELIVERY_RESTAURANTS: "/web-api/restaurant/delivery",
      SET_CATERING_DELIVERY_DETAILS: "/web-api/order/setDeliveryDetails",
      SEARCH_AUTOCOMPLETE: "https://maps.googleapis.com/maps/api/place/autocomplete/json",
      SEARCH_BY_ADDRESS: "https://maps.googleapis.com/maps/api/geocode/json",
      FACEBOOK_USER_INFO_API: "https://graph.facebook.com/me?fields=id,name,email,picture",
      GOOGLE_USER_INFO_API: "https://www.googleapis.com/oauth2/v1/userinfo?alt=json",
      MAPBOX_DISTANCE: "https://api.mapbox.com/directions-matrix/v1/mapbox/driving/{coordinates}?annotations=distance&sources=0",
      MAPBOX_SEARCH_AUTOCOMPLETE: "https://api.mapbox.com/geocoding/v5/mapbox.places/{address}.json?language=en-GB",
      SET_DELIVERY_ADDRESS: "/web-api/order/setDeliveryAddress",
      SET_DELIVERY_TIME: "/web-api/order/setDeliverytime",
      LAST_ORDER_DETAILS: "/web-api/order/lastOrderDetails",
      JOIN_ECLUB: "/web-api/profile/joineClub",
      GET_BEER_MENU_WIDGET: "/web-api/getbeermenuwidget",
      SIGNUP: "/web-api/profile?locale={locale}",
      UPDATE_PROFILE: "/web-api/profile/{userId}",
      RATE_YOUR_VISIT: "/web-api/order/feedback",
      UPDATE_PROFILE_INFO: "/web-api/profile",
      RESET_PASSWORD_REQUEST: "/web-api/profile/passwordresetrequest",
      RESET_PASSWORD: "/web-api/profile/passwordreset",
      REMOVE_GIFT_CARD: "/web-api/giftCard/removeGiftCard",
      INIT_DINE_IN_ORDER: "/web-api/order/initiateDineInOrder?restaurantId={restaurantId}&visitID={visitId}&source={source}&kind={kind}",
      WAITLIST: "/api/waitlist",
      GET_WAIT_TIME: "/api/waitlist/waittime",
      GET_WAITLIST: "/api/waitlist/{waitListId}",
      GET_SETTING_DATA_API: "https://services.darden.com/api/v1",
      LIST_LOCATIONS: "/web-api/locationList",
      PROFILE_VALIDATION_TOKEN: "/web-api/paymentservice/appValidateToken?conceptCode={conceptCode}&locale={locale}",
      CHANGE_PASSWORD: "/web-api/profile/changePassword",
      ORDER_DETAILS: "/web-api/order/details?conceptCode={conceptCode}&locale={locale}",
      GET_VISIT_BY_VISIT_ID: "/api/waitlist/getVisitById",
      GET_VISIT_BY_VISIT_ID_YH: "/wl-home",
      GET_VISIT_BY_TOKEN: "/api/waitlist/getVisitByToken",
      CHECK_IN_VISIT: "/api/waitlist/checkin",
      CANCEL_VISIT: "/api/waitlist/cancel",
      RESERVATION_RESTAURANTS: "/api/restaurants/reservation",
      RESERVATION_RESTAURANT_TIMESLOTS: "/api/reservations/timeslots",
      RESERVATION_AVAILABLE_TIMESLOTS: "/api/reservations/available/timeslots",
      RESERVATIONS: "/api/reservations",
      GET_RESERVATIONS: "/api/reservations/lookup",
      RESERVATION_NOTIFICATION: "/api/reservations/notification",
      GET_TARGETERS: "/web-api/targeter/GetTargeter?targeterPath={targeterPath}&restNumber={restNumber}&conceptCode={conceptCode}&channel={channel}",
      APPLY_BAG_FEE: "/web-api/order/applyBagFee",
      REMOVE_BAG_FEE: "/web-api/order/removeBagFeeFromOrder",
      GUEST_AT_RESTAURANT_VICINITY: "/api/orders/guestvicinity"
    });

    _defineProperty(this, "publicLinks", {
      privacyPolicy: "/privacy-policy",
      terms: "https://contentservicesstg.darden.com/mobileapp/privacy-policy?format=json&channel=mobileapp&concept=OG&locale=en_US&pushSite=oliveGardenMobileSite",
      giftCards: "/gift-cards",
      JoinEClub: "/customer-service/joineclub-step1",
      cateringDelivery: "/delivery/catering-delivery-address",
      doNotSellDataRequest: "https://privacyportal.onetrust.com/webform/ba9aad07-e9b8-4a45-8cfa-96268092be69/d0443d50-5157-4a94-ab3c-7e7a97738a7a",
      faqs: "/faqs",
      legalNotices: "/legal-notices",
      deleteAccount: "https://privacyportal-cdn.onetrust.com/dsarwebform/ba9aad07-e9b8-4a45-8cfa-96268092be69/a1e900a8-bc5c-437d-908a-11bb6e5d1367.html"
    });

    _defineProperty(this, "config", {
      environment: "development",
      local: {
        SERVICES_API_PREFIXES: {
          "/api": "https://atgservicesdev3.darden.com",
          "/web-api": "https://stage-3.olivegarden.com"
        },
        DEFAULT_SERVICES_API_PREFIX: "https://stage-3.olivegarden.com",
        CORS_DOMAIN: "https://cat-ngn.fdmobileservices.com",
        CORS_DOMAIN_RSA: "https://api-int.payeezy.com"
      },
      development: {
        SERVICES_API_PREFIXES: {
          "/api": "",
          "/web-api": ""
        },
        DEFAULT_SERVICES_API_PREFIX: "",
        CORS_DOMAIN: "https://cat-ngn.fdmobileservices.com",
        CORS_DOMAIN_RSA: "https://api-int.payeezy.com"
      },
      production: {
        SERVICES_API_PREFIXES: {
          "/api": "",
          "/web-api": ""
        },
        DEFAULT_SERVICES_API_PREFIX: "",
        CORS_DOMAIN: "https://www.fdmobileservices.com",
        CORS_DOMAIN_RSA: "https://api.payeezy.com"
      }
    });

    _defineProperty(this, "commonQueryParams", void 0);

    _defineProperty(this, "commonHeaders", void 0);

    _defineProperty(this, "commonProps", void 0);

    _defineProperty(this, "conceptCode", void 0);

    _defineProperty(this, "messageEncryptionUtil", void 0);

    _defineProperty(this, "messageEncryptionUtilOpts", void 0);
  }

  _createClass(Config, [{
    key: "getConceptCode",
    value: function getConceptCode() {
      return this.conceptCode;
    }
  }, {
    key: "setConceptCode",
    value: function setConceptCode(conceptCode) {
      this.conceptCode = conceptCode;
    }
  }, {
    key: "setEnvironment",
    value: function setEnvironment(env) {
      this.config.environment = env;
    }
  }, {
    key: "setCommonProps",
    value: function setCommonProps(props) {
      this.commonProps = props;
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      return this.commonProps;
    }
  }, {
    key: "setMessageEncryptionUtil",
    value: function setMessageEncryptionUtil(messageEncryptionUtil) {
      this.messageEncryptionUtil = messageEncryptionUtil;
    }
  }, {
    key: "getMessageEncryptionUtil",
    value: function getMessageEncryptionUtil() {
      return this.messageEncryptionUtil;
    }
  }, {
    key: "setMessageEncryptionOpts",
    value: function setMessageEncryptionOpts(messageEncryptionOptions) {
      this.messageEncryptionUtilOpts = messageEncryptionOptions;
    }
  }, {
    key: "getMessageEncryptionOpts",
    value: function getMessageEncryptionOpts() {
      return this.messageEncryptionUtilOpts;
    }
  }, {
    key: "overrideEndpoint",
    value: function overrideEndpoint(apiPostFix, endpoint) {
      var existing = this.postfix[apiPostFix];

      if (existing) {
        delete this.postfix[apiPostFix];
      }

      this.postfix[apiPostFix] = endpoint;
    }
  }, {
    key: "setCommonQueryParams",
    value: function setCommonQueryParams(queryParams) {
      var env = queryParams.env;

      if (env) {
        var config = this.config[this.config.environment];
        config.ENV = env;
        delete queryParams.env;
      }

      this.commonQueryParams = queryParams;
    }
  }, {
    key: "getCommonQueryParams",
    value: function getCommonQueryParams() {
      return this.commonQueryParams;
    }
  }, {
    key: "setCommonHeaders",
    value: function setCommonHeaders(headers) {
      this.commonHeaders = headers;
    }
  }, {
    key: "getCommonHeaders",
    value: function getCommonHeaders() {
      return this.commonHeaders;
    }
  }, {
    key: "getPrefix",
    value: function getPrefix() {
      return this.config[this.config.environment];
    }
  }, {
    key: "setAPIPrefix",
    value: function setAPIPrefix(apiPrefix, context) {
      var config = this.config[this.config.environment];

      if (context) {
        config.SERVICES_API_PREFIXES[context] = apiPrefix;
      } else {
        if (config.SERVICES_API_PREFIXES) {
          Object.keys(config.SERVICES_API_PREFIXES).forEach(function (ctxt) {
            config.SERVICES_API_PREFIXES[ctxt] = apiPrefix;
          });
        }
      }
    }
  }, {
    key: "setDefaultAPIPrefix",
    value: function setDefaultAPIPrefix(apiPrefix) {
      var config = this.config[this.config.environment];
      config.DEFAULT_SERVICES_API_PREFIX = apiPrefix;
    }
  }, {
    key: "getDefaultAPIPrefix",
    value: function getDefaultAPIPrefix() {
      var config = this.config[this.config.environment];
      return config.DEFAULT_SERVICES_API_PREFIX;
    }
  }, {
    key: "getGiftCardType",
    value: function getGiftCardType() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "US";

      if (this.conceptCode) {
        switch (this.conceptCode) {
          case "YH":
            return "YRDHSE";

          case "OG":
            return location === "US" ? "OLIUSA" : "OLICAN";

          case "CS":
            return "CHEDDARS";

          case "LH":
            return "LNHORN";

          case "BB":
            return "BAHAMA";

          case "S52":
            return "SEAS52";

          case "CG":
            return "CAPGRL";

          case "EV":
            return "EDDIEV";

          case "CB":
            return "CAPGRL";

          default:
            return "DDCORP";
        }
      } else {
        return "OLIUSA";
      }
    }
  }, {
    key: "getSiteIds",
    value: function getSiteIds() {
      switch (this.conceptCode) {
        case "YH":
          return {
            mobileSiteId: "YardHouseMobileSite",
            siteId: "YardHouseSite"
          };

        case "OG":
          return {
            mobileSiteId: "oliveGardenMobileSite",
            siteId: "oliveGardenSite"
          };

        case "CS":
          return {
            mobileSiteId: "CheddarsMobileSite",
            siteId: "CheddarsSite"
          };

        case "LH":
          return {
            mobileSiteId: "longHornMobileSite",
            siteId: "LongHornSite"
          };

        case "BB":
          return {
            mobileSiteId: "BahamaBreezeMobileSite",
            siteId: "BahamaBreezeSite"
          };

        case "S52":
          return {
            mobileSiteId: "Seasons52MobileSite",
            siteId: "Seasons52Site"
          };

        case "CG":
          return {
            mobileSiteId: "The Capital Grille Mobile Site",
            siteId: "CapitalGrilleSite"
          };

        case "EV":
          return {
            mobileSiteId: "5600003",
            siteId: "EddieVSite"
          };

        case "CB":
          return {
            mobileSiteId: "CapitalGrilleBurgerMobile",
            siteId: "CapitalGrilleBurger"
          };

        default:
          return {
            mobileSiteId: null,
            siteId: null
          };
      }
    }
  }, {
    key: "getDardenChannel",
    value: function getDardenChannel() {
      return {
        appChannel: "DARDENMOBILEAPP",
        webChannel: null
      };
    }
  }, {
    key: "getSignUpSource",
    value: function getSignUpSource() {
      var flow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "CREATE_ACCOUNT";
      var APP_SOURCE_PREFIX = this.conceptCode.toLowerCase();
      var SOURCE = SIGNUP_SOURCE[flow];

      if (APP_SOURCE_PREFIX) {
        return {
          appSource: "".concat(APP_SOURCE_PREFIX, "_mapp_").concat(SOURCE)
        };
      } else {
        return {
          appSource: null
        };
      }
    }
  }]);

  return Config;
}();

export { Config as default };